import { Grid, FormControl, MenuItem, TextField, Button, Container, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CardsReport from '../../components/platform-report/CardsReport';
import './platform.css'
import { useSelector, useDispatch } from 'react-redux';
import { getAllCampaignsReport } from '../../redux/actions/platformReport';
import DateRangePicker from '../../components/dateTimePicker/CalenderForReport';
import Loader from '../../components/loader/Loader';
import axios from 'axios';
import { PLATFORM_REPORT_SUMMARY_LOADED, platformSummary } from '../../redux/actions/reportSummary.action';
import { useLocation } from 'react-router-dom';
import { REPORT_END_DATE_STORAGE, REPORT_START_DATE_STORAGE } from '../../redux/actions/dateData.action';
import { motion } from 'framer-motion';

const PlatFormUser = () => {
    const [value, setValue] = useState("");
    const dispatch = useDispatch();
    const {
        campaigns,
        startDate,
        endDate,
        summary,
        brands
    } = useSelector((state) => ({
        campaigns: state?.platformReportReducer?.campaigns,
        startDate: state?.DateDataStorage?.startDate,
        endDate: state?.DateDataStorage?.endDate,
        summary: state?.reportSummaryReducer?.summary?.data?.data,
    }));


    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        dispatch(getAllCampaignsReport())
    }, [])


    const handleChange = (event) => {
        if (value) {
            setValue("")
            dispatch(({
                type: PLATFORM_REPORT_SUMMARY_LOADED,
                payload: ""
            }))
        }
        setValue(event.target.value);
    };




    const handleReportPlatform = async () => {
        const reportDomain = process.env.REACT_APP_BASE_REPORT_PLATFORM;
        setIsLoading(true);

        try {
            let summaryUrl = `${reportDomain}summary?startDate=${startDate}&endDate=${endDate}`;//user 

            if (value !== "all") {
                summaryUrl += `&campaign_id=${value}`;
            }

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const [summaryResponse] = await Promise.all([
                axios.get(summaryUrl,config)
            ]);

            setIsLoading(false);

            if (summaryResponse.data) {
                dispatch(platformSummary(summaryResponse.data));
            }
        } catch (error) {
            console.log(error, "error");
            setIsLoading(false);
        }
    };

    const { pathname } = useLocation()

    useEffect(() => {
        if (pathname === "/platform-report/user") {
            dispatch(({
                type: PLATFORM_REPORT_SUMMARY_LOADED,
                payload: ""
            }))
        }
    }, [])



    return (
        <Container className="platform-user-management">
            <motion.div
                className="platform-user-intro"
                initial={{ opacity: 0, y: -16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut" }}
            >
                <h2>Platform User Summary Overview</h2>
                <p>
                    Select a campaign and date range to generate consolidated user-level platform report insights.
                </p>
            </motion.div>
            <Grid container item direction="row" columnSpacing={2} >
                <Grid container item direction="column" spacing={1} xs={4}>
                    <FormControl fullWidth>
                        <TextField
                            select
                            label="Select Your Campaigns"
                            value={value}
                            onChange={handleChange}
                            fullWidth
                        >
                            {campaigns?.length > 0 ? (
                                campaigns.map((item, index) => (
                                    <MenuItem key={index} value={item?.campaign_id}>
                                        {item?.title}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No campaigns available</MenuItem>
                            )}
                        </TextField>
                    </FormControl>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={8}>
                    {value ? <DateRangePicker /> : ""}
                </Grid>
            </Grid>
            <div className='button_center'>
                <Button
                    sx={{
                        background: 'linear-gradient(135deg, #ffffff 30%, #f0f0f0 90%)',
                        color: '#2f2b3de6',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
                        padding: '0.5rem 1rem',
                        fontSize: "15px",
                        transition: 'all 0.3s ease',
                        marginBottom: '20px',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #f0f0f0 30%, #e0e0e0 90%)',
                            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                    onClick={handleReportPlatform} disabled={!value}>Get Campaigns Report</Button>
            </div>
            <div className='donut-chart'>
                {
                    isLoading ?
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="70vh"
                            animation="wave"
                            sx={{ borderRadius: '12px' }}
                        />
                        :
                        <>
                            <Grid container direction="row" item xs={12} spacing={1}>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    <CardsReport data={summary} />
                                </Grid>
                            </Grid>
                        </>
                }
            </div>
        </Container>
    );
};

export default PlatFormUser;
